<template>
  <a-layout class="components-layout-demo-custom-trigger">
    <a-layout-sider v-model="collapsed" :trigger="null" collapsible>
      <div class="logo" :style="!collapsed ? '' : 'background: none'">
        <span v-if="!collapsed">Starmerx</span>
        <img v-else alt="logo" src="../../assets/logo.png" />
      </div>
      <a-menu v-model="currentMenu" theme="dark" mode="inline" :default-selected-keys="['Dashboard']" :openKeys="openKeys" @openChange="openChange">
        <template v-for="item in filterRoutes">
          <a-menu-item v-if="!item.children" :key="item.path" @click="titleClick">
            {{ item.key }}
            <a-icon type="pie-chart" />
            <span>{{ item.meta.name }}</span>
          </a-menu-item>
          <sub-menu v-else :key="item.path" :menu-info="item" @click="titleClick" />
        </template>

        <!-- <sidebar-item v-for="route in filterRoutes" :key="route.path" :item="route" /> -->
        <!-- <template v-for="route of filterRoutes">
          <a-menu-item v-if="route.onlyOneChild" :key="route.path" @click="titleClick">
            <a-icon :type="route.meta.icon" />
            <span>{{ route.meta.name }}</span>
          </a-menu-item>
          <a-sub-menu v-else :key="route.path">
            <p slot="title"><a-icon :type="route.meta.icon" /><span  v-if="!collapsed">{{ route.meta.name }}</span></p>
              <a-menu-item v-for="item in route.children" :key="item.path" :name="item.meta.name" @click="titleClick">
                <span>{{ item.meta.name }}</span>
                {{ item.children }}
                <a-sub-menu v-if="item.children">
                  <a-menu-item  v-for="item2 in item.children" :key="item2.path" :name="item2.meta.name" @click="titleClick">
                    <span>{{ item2.meta.name }}</span>
                  </a-menu-item>
                </a-sub-menu>
              </a-menu-item>
          </a-sub-menu>
        </template> -->
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background: #fff; padding: 0">
        <a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="() => (collapsed = !collapsed)" />
        <a-dropdown style="float: right; margin-right: 50px">
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            {{ name }}
          </a>
          <a-menu slot="overlay">
            <a-menu-item key="0">
              <span @click="logout">退出登录</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-layout-header>
      <a-layout-content :style="{ margin: '24px 16px', padding: '24px', background: '#fff' }">
        <router-view :key="path" />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { mapGetters } from 'vuex'
import { Menu } from 'ant-design-vue'
import { logout } from '@/api/common'
const SubMenu = {
  template: `
      <a-sub-menu :key="menuInfo.path" v-bind="$props" v-on="$listeners">
        <span slot="title">
          <a-icon :type="menuInfo.meta.icon" /><span>{{ menuInfo.meta.name }}</span>
        </span>
        <template v-for="item in menuInfo.children">
          <a-menu-item v-if="!item.children" :key="item.path" @click="titleClick">
            <span>{{ item.meta.name }}</span>
          </a-menu-item>
          <sub-menu v-else :key="item.path" :menu-info="item" />
        </template>
      </a-sub-menu>
    `,
  name: 'SubMenu',
  // must add isSubMenu: true
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    // Cannot overlap with properties within Menu.SubMenu.props
    menuInfo: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    titleClick() {
      this.$emit('titleClick')
    }
  }
}
export default {
  components: { SubMenu },
  data() {
    return {
      collapsed: false,
      filterRoutes: [],
      path: '',
      currentMenu: [],
      openKeys: [],
      fatherMenuObj: {}
    }
  },
  created() {
    this.dealWithRoute()
    this.currentMenu = [this.$route.path]
    if (this.fatherMenuObj[this.$route.path]) {
      //  检查有没有对应的父路由来展开菜单
      this.openChange([this.fatherMenuObj[this.$route.path]])
    }
  },
  computed: {
    ...mapGetters(['docRoutes', 'name', 'routes'])
  },
  watch: {
    docRoutes() {
      // this.dealWithRoute()
    },
    $route() {
      this.currentMenu = [this.$route.path]
    },
    collapsed() {
      if (this.collapsed) {
        this.openChange([])
      } else {
        this.openChange([this.fatherMenuObj[this.$route.path]])
      }
    }
  },
  methods: {
    dealWithRoute() {
      this.filterRoutes = this.filterHidden(this.routes)
      console.log(this.filterRoutes)
    },
    filterHidden(route) {
      return route.filter(x => {
        if (x.children) {
          x.children = this.filterHidden(x.children)
          x.children.map(y => {
            this.fatherMenuObj[y.path] = x.path // 保存子路由对应的父路由，以刚进页面时展开菜单
          })
          if (!x.children.length) {
            delete x.children
          }
          if (x.children && x.children.length === 1 && !x.type && !x.meta.alwaysShow) {
            x.onlyOneChild = true
            x.path = x.children[0].path
            x.meta = x.children[0].meta
            delete x.children
          }
        } else if (x.type === 'title') {
          x.children = []
        }
        return !x.hidden
      })
    },
    titleClick(v) {
      if (this.$route.path === v.key) {
        return
      }
      this.$router.push({ path: v.key })
      this.path = v.key
    },
    openChange(c) {
      this.openKeys = c
    },
    logout() {
      logout()
    }
  }
}
</script>
<style scoped>
.logo {
  text-align: center;
  font-size: 20px;
  color: white;
  font-weight: 700;
  user-select: none;
}
.logo img {
  width: 100%;
  height: 100%;
}
.components-layout-demo-custom-trigger {
  height: 100vh;
}
.components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

.components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

.components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}
</style>
